<template>
    <div>
        <div style="position: relative; min-height: 100px;">
            <div class="cogs">
              <div class="cog--left" :style="cogBackground"></div>
              <div class="cog--right" :style="cogBackground"></div>
              <div class="cog--center" :style="cogBackground"></div>
            </div>
              <div class="cog-text" :style="'color: ' + this.color">{{ currentMessage }}</div>
        </div>
    </div>
</template>

<style>
    .cog-text {
            position: absolute;
            top: 70px;
            left: 50%;
            transform: translateX(-50%);
            font-size: .9rem;
    }
    /* https://codepen.io/michaellee/pen/spFcB */
    .cog--left, .cog--right, .cog--center {
  background-repeat: no-repeat;
  position: absolute;
  -webkit-animation-name: spinning;
  -moz-animation-name: spinning;
  animation-name: spinning;
  -webkit-animation-duration: 6s;
  -moz-animation-duration: 6s;
  animation-duration: 6s;
  -webkit-animation-timing-function: linear;
  -moz-animation-timing-function: linear;
  animation-timing-function: linear;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  height: 32px;
  width: 32px;
}

.cog--left {
  left: 10px;
  top: 0px;
}

.cog--right {
  left: 32px;
  top: 15px;
  -webkit-animation-direction: reverse;
  -moz-animation-direction: reverse;
  animation-direction: reverse;
}

.cog--center {
  left: -12px;
top: 15px;
  -webkit-animation-direction: reverse;
  -moz-animation-direction: reverse;
  animation-direction: reverse;
}

.cogs {
  margin: auto;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  height: 74px;
  width: 54px;
}

@-webkit-keyframes spinning {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@-moz-keyframes spinning {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(360deg);
  }
}
@keyframes spinning {
  from {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

</style>

<script>
    let interval;

    export default {
        props: {
            color: {
              type: String,
              default: '#42526e',
            },
            startOnMount: {
              type: Boolean,
              default: false,
            },
            strings: {
                type: Array,
                default: function() {
                    return [
                        'Loading, please wait',
                        'Hang tight',
                        'We\'re working on it',
                        'Nearly there',
                        'This is taking a little while',
                    ];
                }
            }
        },
        mounted() {
          if (this.startOnMount) {
            this.start();
          }
        },
        data() {
            return {
                index: 0,
                currentMessage: null,
            }
        }, 
        computed: {
          encodedColor() {
            return encodeURIComponent(this.color);
          },
          cogBackground() {
            return "background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0D%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20x%3D%220px%22%20y%3D%220px%22%20width%3D%2232px%22%20height%3D%2232px%22%20viewBox%3D%220%200%2032%2032%22%20enable-background%3D%22new%200%200%2032%2032%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%0A%20%20%3Cg%20id%3D%22settings%22%3E%0D%0A%20%20%20%20%3Cpath%20d%3D%22M30.391%2C12.68l-3.064-0.614c-0.154-0.443-0.336-0.873-0.537-1.289l1.736-2.604%26%2310%3B%20%20%20%20%20%20%20%20c0.529-0.793%2C0.424-1.85-0.25-2.523l-1.924-1.924c-0.387-0.387-0.898-0.586-1.416-0.586c-0.383%2C0-0.77%2C0.11-1.107%2C0.336%26%2310%3B%20%20%20%20%20%20%20%20l-2.604%2C1.735c-0.418-0.202-0.848-0.382-1.291-0.536L19.32%2C1.61c-0.186-0.936-1.008-1.608-1.961-1.608h-2.72%26%2310%3B%20%20%20%20%20%20%20%20c-0.953%2C0-1.774%2C0.673-1.961%2C1.608l-0.614%2C3.065c-0.443%2C0.154-0.873%2C0.335-1.289%2C0.536L8.172%2C3.476%26%2310%3B%20%20%20%20%20%20%20%20C7.833%2C3.25%2C7.447%2C3.14%2C7.063%2C3.14c-0.517%2C0-1.028%2C0.199-1.415%2C0.586L3.725%2C5.65c-0.674%2C0.674-0.779%2C1.73-0.25%2C2.523l1.735%2C2.604%26%2310%3B%20%20%20%20%20%20%20%20c-0.202%2C0.417-0.382%2C0.847-0.536%2C1.29L1.608%2C12.68C0.673%2C12.867%2C0%2C13.688%2C0%2C14.641v2.72c0%2C0.953%2C0.673%2C1.775%2C1.608%2C1.961%26%2310%3B%20%20%20%20%20%20%20%20l3.065%2C0.615c0.154%2C0.443%2C0.335%2C0.873%2C0.536%2C1.289L3.475%2C23.83c-0.529%2C0.793-0.424%2C1.85%2C0.25%2C2.523l1.924%2C1.924%26%2310%3B%20%20%20%20%20%20%20%20c0.387%2C0.387%2C0.898%2C0.586%2C1.415%2C0.586c0.384%2C0%2C0.771-0.111%2C1.108-0.336l2.604-1.736c0.417%2C0.203%2C0.847%2C0.383%2C1.29%2C0.537%26%2310%3B%20%20%20%20%20%20%20%20l0.613%2C3.064c0.187%2C0.936%2C1.008%2C1.609%2C1.961%2C1.609h2.72c0.953%2C0%2C1.775-0.674%2C1.961-1.609l0.615-3.064%26%2310%3B%20%20%20%20%20%20%20%20c0.443-0.154%2C0.873-0.336%2C1.289-0.537l2.604%2C1.736c0.338%2C0.225%2C0.725%2C0.336%2C1.107%2C0.336c0.518%2C0%2C1.029-0.199%2C1.416-0.586%26%2310%3B%20%20%20%20%20%20%20%20l1.924-1.924c0.674-0.674%2C0.779-1.73%2C0.25-2.523l-1.736-2.604c0.203-0.418%2C0.383-0.848%2C0.537-1.291l3.064-0.613%26%2310%3B%20%20%20%20%20%20%20%20C31.326%2C19.137%2C32%2C18.314%2C32%2C17.361v-2.72C32%2C13.688%2C31.326%2C12.867%2C30.391%2C12.68z%20M26.934%2C17.975%26%2310%3B%20%20%20%20%20%20%20%20c-0.695%2C0.139-1.264%2C0.635-1.496%2C1.305c-0.129%2C0.369-0.279%2C0.727-0.447%2C1.074c-0.311%2C0.639-0.258%2C1.393%2C0.135%2C1.982l1.736%2C2.604%26%2310%3B%20%20%20%20%20%20%20%20l-1.924%2C1.924l-2.604-1.736c-0.334-0.223-0.721-0.336-1.109-0.336c-0.297%2C0-0.596%2C0.066-0.871%2C0.199%26%2310%3B%20%20%20%20%20%20%20%20c-0.348%2C0.168-0.705%2C0.32-1.076%2C0.449c-0.668%2C0.232-1.164%2C0.801-1.303%2C1.496l-0.615%2C3.066h-2.72l-0.613-3.066%26%2310%3B%20%20%20%20%20%20%20%20c-0.139-0.695-0.635-1.264-1.304-1.496c-0.369-0.129-0.728-0.279-1.075-0.447c-0.276-0.135-0.574-0.201-0.872-0.201%26%2310%3B%20%20%20%20%20%20%20%20c-0.389%2C0-0.775%2C0.113-1.109%2C0.336l-2.604%2C1.736l-1.924-1.924l1.735-2.604c0.393-0.59%2C0.444-1.344%2C0.137-1.98%26%2310%3B%20%20%20%20%20%20%20%20c-0.168-0.348-0.319-0.705-0.448-1.076c-0.232-0.668-0.802-1.164-1.496-1.303l-3.065-0.615L2%2C14.641l3.066-0.613%26%2310%3B%20%20%20%20%20%20%20%20c0.694-0.139%2C1.264-0.635%2C1.496-1.304c0.129-0.369%2C0.278-0.728%2C0.447-1.075c0.31-0.638%2C0.258-1.392-0.136-1.981L5.139%2C7.064%26%2310%3B%20%20%20%20%20%20%20%20L7.062%2C5.14l2.604%2C1.735C10%2C7.098%2C10.387%2C7.211%2C10.775%2C7.211c0.297%2C0%2C0.595-0.066%2C0.871-0.199c0.347-0.168%2C0.705-0.319%2C1.075-0.448%26%2310%3B%20%20%20%20%20%20%20%20c0.669-0.232%2C1.165-0.802%2C1.304-1.496l0.614-3.065l2.72-0.001l0.613%2C3.066c0.139%2C0.694%2C0.635%2C1.264%2C1.305%2C1.496%26%2310%3B%20%20%20%20%20%20%20%20c0.369%2C0.129%2C0.727%2C0.278%2C1.074%2C0.447c0.277%2C0.134%2C0.574%2C0.2%2C0.873%2C0.2c0.389%2C0%2C0.775-0.113%2C1.109-0.336l2.604-1.735l1.924%2C1.924%26%2310%3B%20%20%20%20%20%20%20%20l-1.736%2C2.604c-0.393%2C0.59-0.443%2C1.343-0.137%2C1.98c0.168%2C0.347%2C0.32%2C0.705%2C0.449%2C1.075c0.232%2C0.669%2C0.801%2C1.165%2C1.496%2C1.304%26%2310%3B%20%20%20%20%20%20%20%20l3.064%2C0.614L30%2C17.361L26.934%2C17.975z%22%20style%3D%22fill%3A"+ this.encodedColor +"%3B%22%2F%3E%0D%0A%20%20%20%20%3Cpath%20d%3D%22M16%2C9.001c-3.865%2C0-7%2C3.135-7%2C7c0%2C3.866%2C3.135%2C7%2C7%2C7s7-3.135%2C7-7C23%2C12.136%2C19.865%2C9.001%2C16%2C9.001z%26%2310%3B%20%20%20%20%20%20%20%20%20M16%2C22.127c-3.382%2C0-6.125-2.744-6.125-6.125c0-3.382%2C2.743-6.125%2C6.125-6.125c3.381%2C0%2C6.125%2C2.743%2C6.125%2C6.125%26%2310%3B%20%20%20%20%20%20%20%20C22.125%2C19.383%2C19.381%2C22.127%2C16%2C22.127z%22%20style%3D%22fill%3A"+ this.encodedColor +"%3B%22%2F%3E%0D%0A%20%20%20%20%3Cpath%20d%3D%22M16%2C12.001c-2.21%2C0-4%2C1.79-4%2C4c0%2C2.209%2C1.79%2C4%2C4%2C4c2.209%2C0%2C4-1.791%2C4-4C20%2C13.792%2C18.209%2C12.001%2C16%2C12.001z%26%2310%3B%20%20%20%20%20%20%20%20%20M16%2C19.002c-1.656%2C0-3-1.344-3-3c0-1.656%2C1.344-3%2C3-3s3%2C1.344%2C3%2C3C19%2C17.658%2C17.656%2C19.002%2C16%2C19.002z%22%20style%3D%22fill%3A"+ this.encodedColor +"%3B%22%2F%3E%0D%0A%20%20%3C%2Fg%3E%0D%0A%3C%2Fsvg%3E);";
          }
        },
        methods: {
            start() {
                clearInterval(interval);
                this.index = 0;
                this.currentMessage = this.strings[this.index];
                this.index++;

                interval = setInterval(() => {
                    this.currentMessage = this.strings[this.index];
                    this.index++;

                    if (this.index >= this.strings.length) {
                        this.index = 0;
                    }
                }, 10000);
            }
        }
    }
</script>